import React from "react";
import { LegalLayout, LegalSection } from "./LegalLayout";

export default function LegalNoticePage() {
  return (
    <LegalLayout
      current="/mentions-legales"
      title="Mentions légales"
      subtitle="Informations relatives à l'éditeur et à l'hébergement de la plateforme PROGÈRE."
      description="PROGÈRE réunit PUNCH, CRM, ERP, COMPTA et DEVIS AI dans un seul écosystème intelligent pensé pour la construction au Québec — un seul portail, une seule connexion. Exploité par Groupe MJR Construction Inc."
      updated="Juillet 2026"
    >
      <LegalSection id="editeur" title="1. Éditeur du site">
        <p>
          <strong className="text-white">PROGÈRE</strong> réunit PUNCH, CRM, ERP, COMPTA et DEVIS AI dans un seul
          écosystème intelligent de gestion pour la construction au Québec — un seul portail, une seule connexion.<br />
          Exploité par <strong className="text-white">Groupe MJR Construction Inc.</strong><br />
          Courriel : info@progere.ca
        </p>
      </LegalSection>

      <LegalSection id="directeur" title="2. Directeur de la publication">
        <p>[Nom du directeur de la publication à compléter]</p>
      </LegalSection>

      <LegalSection id="hebergement" title="3. Hébergement">
        <p>
          La plateforme et les données sont hébergées sur une infrastructure infonuagique située au Canada.
          Les coordonnées complètes de l'hébergeur peuvent être fournies sur demande à info@progere.ca.
        </p>
      </LegalSection>

      <LegalSection id="propriete-intel" title="4. Propriété intellectuelle">
        <p>
          L'ensemble des éléments de la plateforme (marques, logos, textes, interfaces, code) est protégé par les lois applicables
          en matière de propriété intellectuelle et demeure la propriété de Groupe MJR Construction Inc. ou de ses concédants.
          Toute reproduction non autorisée est interdite.
        </p>
      </LegalSection>

      <LegalSection id="donnees" title="5. Protection des données">
        <p>
          Le traitement des renseignements personnels est décrit dans notre{" "}
          <a href="/confidentialite" className="text-[#EAB308] hover:underline">Politique de confidentialité (Loi 25)</a>.
        </p>
      </LegalSection>

      <LegalSection id="contact-ml" title="6. Contact">
        <p>Pour toute question, écrivez-nous à info@progere.ca.</p>
      </LegalSection>
    </LegalLayout>
  );
}
